let cachedConfig = null;

export async function getRuntimeConfig() {
  if (cachedConfig) return cachedConfig;
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (!res.ok) throw new Error('Failed to load config.json');
    cachedConfig = await res.json();
  } catch (err) {
    // Fallback for development if config.json is missing
    cachedConfig = {
      activeStandard: 'CBSE',
      apiBaseUrl: '/api',
      version: '1.0.0'
    };
  }
  return cachedConfig;
}

export function clearRuntimeConfig() {
  cachedConfig = null;
}
